import { DateTime } from "luxon";
import { AppendIfPrefixExists } from "../../../../../modules/sitePaths";

type SpendWidgetViewBy = "category" | "manufacturer";

type BuildSpendWidgetDeepLinkParams = {
  viewBy: SpendWidgetViewBy;
  termMonths: number;
  category?: string;
  manufacturer?: string;
};

export const buildPurchasedAssetsSpendDeepLink = ({
  viewBy,
  termMonths,
  category,
  manufacturer,
}: BuildSpendWidgetDeepLinkParams): string => {
  const endDate = DateTime.local().toISO();
  const startDate = DateTime.local().minus({ months: termMonths }).toISO();
  const filterInclude = `purchaseDate:${startDate ?? ""}~${endDate ?? ""}`;

  const query = new URLSearchParams({
    viewBy,
    filterInclude,
    ...(category ? { category } : {}),
    ...(manufacturer ? { manufacturer } : {}),
  }).toString();

  return `${AppendIfPrefixExists("/assets/purchased-assets")}?${query}`;
};